import type { Fetch } from '@app/types/Global';
import type { ISbStoriesParams, ISbStoryData } from '@storyblok/js';

export const getForwardArticles = async (fetch?: Fetch): Promise<[ISbStoryData]> => {
	const params: ISbStoriesParams = {
		starts_with: 'blog/articles',
		filter_query: {
			isForward: {
				in: true
			},
			component: {
				in: 'article'
			}
		}
	};
	return await sendBlogRequest(params, fetch);
};
export const getBlogCategories = async (fetch?: Fetch): Promise<[ISbStoryData]> => {
	const params: ISbStoriesParams = {
		starts_with: 'blog/categories',
		filter_query: {
			component: {
				in: 'category'
			}
		}
	};
	return await sendBlogRequest(params, fetch);
};

export const getArticlesByCategories = async (
	categoriesUuid: Array<string>,
	number: number,
	pageNumber: number,
	fetch?: Fetch
): Promise<[ISbStoryData]> => {
	const params: ISbStoriesParams = {
		starts_with: 'blog/articles',
		filter_query: {
			categories: {
				exists: categoriesUuid.join(',')
			}
		},
		page: pageNumber,
		per_page: number
	};
	return await sendBlogRequest(params, fetch, true);
};

export const getCategorieByName = async (
	categorieName: string,
	fetch?: Fetch
): Promise<[ISbStoryData]> => {
	const params: ISbStoriesParams = {
		filter_query: {
			name: {
				like: categorieName
			}
		}
	};
	const result = await sendBlogRequest(params, fetch);
	return result.stories[0];
};

export const getLastArticlesByCategorieName = async (
	number: number,
	categorieName: string,
	fetch?: Fetch
): Promise<[ISbStoryData]> => {
	const categorieUuid = (await getCategorieByName(categorieName, fetch)).uuid;
	const params: ISbStoriesParams = {
		starts_with: 'blog/articles',
		filter_query: {
			categories: {
				exists: categorieUuid
			}
		},
		sort_by: 'created_at:desc',
		page: 1,
		per_page: number
	};
	return await sendBlogRequest(params, fetch);
};

export const getLastArticles = async (number: number, fetch?: Fetch): Promise<[ISbStoryData]> => {
	const params: ISbStoriesParams = {
		starts_with: 'blog/articles',
		filter_query: {
			component: {
				in: 'article'
			},
			isHomepageVisible: {
				is: true
			}
		},
		sort_by: 'created_at:desc',
		page: 1,
		per_page: number
	};
	return await sendBlogRequest(params, fetch);
};
export const getAllArticlesForSitemap = async (fetch?: Fetch): Promise<[ISbStoryData]> => {
	const params: ISbStoriesParams = {
		starts_with: 'blog/articles'
	};
	return await sendBlogRequest(params, fetch);
};

export const getCategoriesWithArticles = async (fetch?: Fetch): Promise<[ISbStoryData]> => {
	const categories = await getBlogCategories(fetch);
	await Promise.all(
		categories.stories.map(async (category) => {
			category.articles = await getArticlesByCategories([category.uuid], 4, 1, fetch);
		})
	);
	return categories;
};

const sendBlogRequest = async (
	params: ISbStoriesParams,
	fetch?: Fetch | null,
	getHeader?: boolean
) => {
	const queryString = JSON.stringify({
		...params
	});
	const result = await (await fetch(`/cms/blog?params=${queryString}`)).json();

	return getHeader ? result : result.data;
};
